import _ from "underscore";
import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../storeUtils";

const initialState = {
  showLoaderComponentEMS: false,
  templateImport: {},
  configuration: {},
  templateImportFail: {},
  loggedInUser: {},
  activeAdminTab: "TMF structure",
  tmfStructureData: {},
  zoneData: [],
  orgTemplates: [],
  studyTemplates: [],
  viedocTemplates: [],
  selectedTempID: "",
  isLoading: false,
  selectedLoading: false,
  loadingTempID: "",
  instantiateLoading: false,
  viewDialog: {
    open: false,
    from: "",
    zoneData: {},
    sectionData: {},
    artifactData: {},
  },
  exportingList: [],
  deletedTempID: "",
  eTMFArchivingLoading: false,
  isExporting: false,
  archiveErrStatus: "",
  eTMFArchiveTab: {},
  templateImporting: "",
  maintenanceStatus: "",
  mileStoneList: [],
  countryList: [],
  siteList: [],
  milestoneDropDownList: {},
  milestoneGroupList: [],
  datingConventionList: [],
  artifactFail: "",
  isEditLoading: false,
  rawDatingConventionList: [],
  changeditems: "",
  ischangefound: false,
  revertChange: {},
  applyChange: {},
  isChangeLoading: false,
  fileScreeningStatus: {},
  mileStoneInfoList: {},
  viewMilestoneListLoading: false,
  isViewMilestoneList: false,
  mileStoneObjInfo: {},
  milestoneCount: 0,
  isMilestoneViewLoading: false,
  isSingleMilestoneView: false,
  artifactCount: 0,
  artifactList: [],

  mileStoneListWithGroup: [],
  milestoneGroup: [],
  mileStoneLastModified: "",
  milestoneActionFail: "",
  isArtifactEditSuccess: false,
  isMilestoneChanged: false,
  errorFields: [],
  formErrorValues: {},
  isArchiveLoading: false,
  latestArchiveInfo: [],
  isGeneratingAuditTrail: false,
  generateAuditTrailInfo: {},
  isCancelBeforeSuccess: false,
  isCancelLoading: false,
  settings: {
    ismilestoneenabled: false,
    islockdoconapproveenabled: false,
    isreasonforunlockdocenabled: false,
    isshareddropzoneenabled: false,
    isprivatedropzoneenabled: false,
    istmflevelenabled: false,
    isaggridincluded: false,
    displaytemplate: "",
    downloadtemplate: "",
    archivetemplate: "",
    showstructurenumber: false,
  },
  sharedenabled: true,
  privateenabled: false,
  sharedfilecount: 1,
  privatefilecount: 1,
  dropZoneFileScreeningStatus: {},
  isDropZoneCancelBeforeSuccess: false,
  progressDropZoneFiles: [],
  invalidDoc: [],
  dropZoneDoc: [],
  activeDropzone: "",
  downloadingFiles: [],
  lockStatus: "",
  isEtmfLocked: false,
  isLockLoading: false,
  agGridFrom: "",
  customizedColState: "undefined",
  customizedFilterState: "undefined",
  lastMode: "",
  presentMode: "",
  isSearchHappend: false,
  isCloseHappend: false,
  isTemplateCancel: false,
  datePattern: "",
  fullDateTimePattern: "",
  dateLocale: "en-us",
  isTmfStructDetailsLoading: false,
  structurename: "",
  structureversion: "",
  tmfmodelversion: "",
  isInitialArchiveCancel:false
};

export const emsReducer = (state = initialState, action = { type: "" }) => {
  switch (action.type) {
    case `${actionTypes.GET_COMPLETE_EMS_TRAIL}_INITIAL`:
      return updateObject(state, { isArchiveLoading: true });
    case `${actionTypes.GET_COMPLETE_EMS_TRAIL}_FAILED`:
      return updateObject(state, { isArchiveLoading: false });
    case `${actionTypes.GET_COMPLETE_EMS_TRAIL}_SUCCESS`:
      return updateObject(state, {
        isArchiveLoading: !action.isFrom, // set this value based on "live" key passed from saga in order to avoid flicker, while transistion between loader to progress bar in archival page.
        latestArchiveInfo: action.payload,
      });
    case actionTypes.GENERATE_COMPLETE_EMS_TRAIL:
      return updateObject(state, {
        isGeneratingAuditTrail: true,
        showLoaderComponentEMS: true,
        isCancelBeforeSuccess: false,
        isCancelLoading: false,
        generateAuditTrailInfo: { percentage: 0 },
      });
    case `${actionTypes.GENERATE_COMPLETE_EMS_TRAIL}_FAILED`:
      return updateObject(state, {
        isGeneratingAuditTrail: false,
        showLoaderComponentEMS: false,
        generateAuditTrailInfo: {},
      });
    case `${actionTypes.GENERATE_COMPLETE_EMS_TRAIL}_SUCCESS`:
      const { percentage, status, latest } = action.payload;
      let updateLatestArchiveInfo = state.latestArchiveInfo;
      if (percentage === 100 && status === "Completed" && !_.isEmpty(latest)) {
        updateLatestArchiveInfo = latest;
      }
      return updateObject(state, {
        isGeneratingAuditTrail: !(
          percentage === 100 || ["Cancelled", "Failed"].includes(status)
        ),
        generateAuditTrailInfo: action.payload,
        latestArchiveInfo: updateLatestArchiveInfo,
        isCancelLoading: state.isCancelLoading
          ? !["Completed", "Cancelled", "Failed"].includes(status)
          : false,
        isArchiveLoading: false,
        showLoaderComponentEMS: false,
      });
    case `${actionTypes.GENERATE_COMPLETE_EMS_TRAIL}_STATUS`:
      return updateObject(state, { showLoaderComponentEMS: false });
    case `${actionTypes.GENERATE_COMPLETE_EMS_TRAIL}_CANCEL`:
      return updateObject(state, {
        generateAuditTrailInfo: {
          percentage: state.generateAuditTrailInfo.percentage,
        },
        isCancelLoading: true,
        showLoaderComponentEMS: false,
      });
    case `${actionTypes.GENERATE_COMPLETE_EMS_TRAIL}_CANCEL_BEFORE_SUCCESS`:
      return updateObject(state, {
        isCancelBeforeSuccess: true,
        isCancelLoading: true,
        isFileDownloading: false,
      });
    case actionTypes.SET_INITIAL_ARCHIVE_CANCEL:
      return updateObject(state, {
         isInitialArchiveCancel: action.payload
      })  
    default:
      return state;
  }
};
